<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          Create Lottery
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <lottery-form ref="form" v-model="lottery" :params="params" @submit="createLottery">
            </lottery-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="
                $router.push({
                  name: $routes.admin.sortitionDisplay.indexRoute.name
                })
              "
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="createLottery">
              Create
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import LotteryForm from "../../../components/lottery/LotteryForm";
import { createLottery } from "../../../../api/lottery.api";
import LotteryCreateUpdate from "./LotteryCreateUpdate";

export default {
  name: "SortitionDisplayCreate",
  components: { LotteryForm },
  extends: LotteryCreateUpdate,
  methods: {
    async createLottery() {
      const valid = await this.$refs.validationObserver.validate();

      if (valid) {
        const { lottery, $routes, $router } = this;

        createLottery(lottery)
          .then(() => {
            $router.push({ name: $routes.admin.lottery.indexRoute.name });
          })
          .catch(error =>
            this.handleErrorResponse(this.$refs.validationObserver, error)
          );
      }
    }
  }
};
</script>

<style scoped></style>
